export default __webpack_public_path__ + "media/images/logo-cbb86ca26bcc5334141c296455239e65.svg";